"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVolumeOnMessage = exports.getVolumeOffMessage = exports.getSourceTooltipMessage = exports.getSoloMessage = exports.getLoopMessage = exports.getFeaturedSourceText = exports.MAX_CAMERA_MESSAGE = void 0;
var _SceneLayouts = require("../../constants/SceneLayouts");
var MAX_CAMERA_MESSAGE = exports.MAX_CAMERA_MESSAGE = "All ".concat(_SceneLayouts.CAMERA_PRESENTER_LIMIT, " of ").concat(_SceneLayouts.CAMERA_PRESENTER_LIMIT, " cameras are in use");
var getFeaturedSourceText = exports.getFeaturedSourceText = function getFeaturedSourceText() {
  return 'Source_Pinned_Popover';
};
var getVolumeOnMessage = exports.getVolumeOnMessage = function getVolumeOnMessage() {
  return 'Volume_Off_Popover';
};
var getVolumeOffMessage = exports.getVolumeOffMessage = function getVolumeOffMessage() {
  return 'Volume_On_Popover';
};
var getSoloMessage = exports.getSoloMessage = function getSoloMessage() {
  return 'Source_Spotlight_Popover';
};
var getLoopMessage = exports.getLoopMessage = function getLoopMessage() {
  return 'Loop_Button_Popover';
};
var getSourceTooltipMessage = exports.getSourceTooltipMessage = function getSourceTooltipMessage(sourceType, isStaged, translate) {
  var label = sourceType === 'cameraPresenter' ? translate('Speaker_Selected_Popover') : translate('Source_Selected_Popover');
  return isStaged ? "".concat(translate('Deselect_Source_Popover'), " ").concat(label) : "".concat(translate('Select_Source_Popover'), " ").concat(label);
};